const ORDINALS: Record<string, number> = {
  первый: 1, второй: 2, третий: 3, четвертый: 4, четвёртый: 4,
  пятый: 5, шестой: 6, седьмой: 7, восьмой: 8, девятый: 9, десятый: 10,
  first: 1, second: 2, third: 3, fourth: 4, fifth: 5,
  sixth: 6, seventh: 7, eighth: 8, ninth: 9, tenth: 10,
};

/** Keep a requested season separate from the title sent to TMDb. */
export function parseSeriesSeasonQuery(query: string): { title: string; seasonNumber: number } | null {
  const trimmed = query.trim();
  const value = '(?:[1-9]\\d?|первый|второй|третий|четв[её]ртый|пятый|шестой|седьмой|восьмой|девятый|десятый|first|second|third|fourth|fifth|sixth|seventh|eighth|ninth|tenth)';
  const suffix = '(?:\\s+(?:из|of)\\s+\\d{1,2})?';
  const match = trimmed.match(new RegExp(`^(.+?)\\s+(?:(?:сезон|season)\\s*(${value})|(${value})(?:[- ]?(?:й|ый|ой|st|nd|rd|th))?\\s+(?:сезон|season)|s(\\d{1,2}))${suffix}$`, 'iu'));
  if (!match) return null;
  const raw = (match[2] ?? match[3] ?? match[4]).toLowerCase();
  const seasonNumber = ORDINALS[raw] ?? Number(raw);
  return Number.isInteger(seasonNumber) && seasonNumber > 0 && seasonNumber <= 99
    ? { title: match[1].trim(), seasonNumber }
    : null;
}
